<!-- <lm-page-header pageTitle="Admin" [breadcrumbs]="breadcrumbs">
  <lm-action-bar [actions]="actions"></lm-action-bar>
</lm-page-header> -->
<lm-container class="bg-[#F6F6F6]" *transloco="let t">
  <lm-row>
    <lm-column class="w-6/12">
      <h1 class="font-bold uppercase mb-4">buttons primary</h1>
      <div class="flex gap-x-8">
        <lm-button
          (click)="onConfirm()"
          [options]="{ color: 'primary', size: 'small', type: 'button', disabled: false }"
          >label xsmall</lm-button
        >
        <lm-button (click)="onOpenModal()" 
          [options]="{ color: 'primary', size: 'default', type: 'button', disabled: false }"
          >label small</lm-button
        >
        <lm-button [options]="{ color: 'primary', size: 'large', type: 'button', disabled: false }"
          >label large</lm-button
        >
        <lm-button [disabled]="true">disabled</lm-button>
      </div>
    </lm-column>
    <lm-column class="w-6/12">
      <h1 class="font-bold uppercase mb-4">buttons secondary</h1>
      <div class="flex gap-x-8">
        <lm-button [options]="{ color: 'secondary', size: 'small', type: 'button', disabled: false }"
          >label xsmall</lm-button
        >
        <lm-button [options]="{ color: 'secondary', size: 'default', type: 'button', disabled: false }"
          >label small</lm-button
        >
        <lm-button [options]="{ color: 'secondary', size: 'large', type: 'button', disabled: false }"
          >label large</lm-button
        >
        <lm-button color="secondary" [disabled]="true">disabled</lm-button>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-6/12">
      <h1 class="font-bold uppercase mb-4">buttons tertiary</h1>
      <div class="flex gap-x-8">
        <lm-button [options]="{ color: 'tertiary', size: 'small', type: 'button', disabled: false }"
          >label xsmall</lm-button
        >
        <lm-button [options]="{ color: 'tertiary', size: 'default', type: 'button', disabled: false }"
          >label small</lm-button
        >
        <lm-button [options]="{ color: 'tertiary', size: 'large', type: 'button', disabled: false }"
          >label large</lm-button
        >
        <lm-button color="tertiary" [disabled]="true">disabled</lm-button>
      </div>
    </lm-column>
    <lm-column class="w-6/12">
      <h1 class="font-bold uppercase mb-4">buttons tertiary /icon</h1>
      <div class="flex gap-x-8">
        <lm-button [options]="{ color: 'tertiary', size: 'small', type: 'button', disabled: false }" [icon]="arrowRight"
          >label xsmall</lm-button
        >
        <lm-button
          [options]="{ color: 'tertiary', size: 'default', type: 'button', disabled: false }"
          [icon]="arrowRight"
          >label small</lm-button
        >
        <lm-button [options]="{ color: 'tertiary', size: 'large', type: 'button', disabled: false }" [icon]="arrowRight"
          >label large</lm-button
        >
        <lm-button color="tertiary" [disabled]="true" [icon]="arrowRight">disabled</lm-button>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-6/12">
      <h1 class="font-bold uppercase mb-4">icons</h1>
      <div class="flex gap-x-8">
        <lm-icon [icon]="faEdit"></lm-icon>
        <lm-icon [icon]="faPlus" size="large"></lm-icon>
        <lm-icon [icon]="faEdit" [disabled]="true"></lm-icon>
        <lm-icon [icon]="faEdit" [onlyIcon]="true"></lm-icon>
        <div class="bg-green-active p-2 px-5">
          <lm-icon [icon]="faEdit" [onlyIcon]="true" color="light"></lm-icon>
        </div>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-3/12">
      <h1 class="font-bold uppercase mb-4">card -filled</h1>
      <lm-dropdown>
        <lm-card>
          <lm-card-header lmDropdownToggle>Titolo card header</lm-card-header>
          <lm-card-content lmDropdownContainer><div class="py-4">Contenuto title 1</div></lm-card-content>
          <lm-card-footer>
            <div class="flex justify-between items-center">
              <lm-icon [icon]="faEllipsis"></lm-icon>
              <lm-button size="small">label xsmall</lm-button>
            </div>
          </lm-card-footer>
        </lm-card>
      </lm-dropdown>
    </lm-column>
    <lm-column class="w-3/12">
      <h1 class="font-bold uppercase mb-4">card -elevated</h1>
      <lm-card [elevated]="true">
        <lm-card-header>Titolo card header</lm-card-header>
        <lm-card-content><div class="py-4">Contenuto title 1</div></lm-card-content>
        <lm-card-footer>
          <div class="flex justify-between items-center">
            <lm-icon [icon]="faEllipsis"></lm-icon>
            <lm-button size="small" color="tertiary">label xsmall</lm-button>
          </div>
        </lm-card-footer>
      </lm-card>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-3/12">
      <h1 class="font-bold uppercase mb-4">slider</h1>
      <lm-slider-range></lm-slider-range>
    </lm-column>
    <lm-column class="w-3/12">
      <h1 class="font-bold uppercase mb-4">checkbox</h1>
      <div class="flex gap-8">
        <lm-checkbox label="Small"></lm-checkbox>
        <lm-checkbox size="large" label="Large"></lm-checkbox>
        <lm-checkbox size="large" label="Disabled" [isDisabled]="true"></lm-checkbox>
      </div>
    </lm-column>
    <lm-column class="w-3/12">
      <h1 class="font-bold uppercase mb-4">Progress Bar</h1>
      <div class="grid gap-y-6">
        <lm-progressbar [progress]="progress"></lm-progressbar>
        <lm-progressbar [progress]="progress" size="small"></lm-progressbar>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column>
      <h1 class="font-bold uppercase mb-4">Tags</h1>
      <div class="flex gap-x-5">
        <span lmTag color="green">Complete</span>
        <span lmTag color="orange">Draft</span>
        <span lmTag color="disabled">Disable</span>
        <!-- <div lmTag color="disabled" class="h-8 rounded-2xl">
          <span class="text-focus-green">COMPLETE</span>
          <fa-icon [icon]="faClose" class="text-focus-green text-sm ml-[5px]"></fa-icon>
        </div> -->
        <span lmTag color="red">Errore</span>
        <span lmTag>In progress</span>
      </div>
    </lm-column>
    <lm-column>
      <h1 class="font-bold uppercase mb-4">Label</h1>
      <div class="flex gap-x-5">
        <span lmLabel color="green">Complete/active</span>
        <span lmLabel color="orange">draft</span>
        <span lmLabel color="red">errore</span>
        <span lmLabel color="disabled">disable</span>
        <span lmLabel>normal</span>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-4/12">
      <h2 class="font-bold uppercase mb-4">Datepicker</h2>
      <lm-date-picker label="Title input" placeholder="Inserisci data" [options]="datePickerOptions()"></lm-date-picker>
      <lm-date-picker
        size="large"
        label="Title input"
        placeholder="Inserisci data"
        [options]="datePickerOptions()"
        plugin="monthSelect"
      ></lm-date-picker>
    </lm-column>
    <!-- <lm-column class="w-4/12">
      <h2 class="font-bold uppercase mb-4">Text Input</h2>
      <lm-input-text label="Title input" placeholder="Placeholder"></lm-input-text>
      <lm-input-text label="Title input" placeholder="Placeholder" size="large" [disabled]="true"></lm-input-text>
    </lm-column> -->
    <lm-column class="w-4/12">
      <h2 class="font-bold uppercase mb-4">Select</h2>
      <lm-ng-select label="Title input" [multiple]="true" placeholder="Placeholder" [data]="selectData"></lm-ng-select>
     <lm-ng-select customClass="hide-preview-multiple-select" label="Title input" [multiple]="true" placeholder="Placeholder" [data]="selectDataMultiple"></lm-ng-select>
      <lm-ng-select label="Title input" placeholder="Placeholder" [data]="selectData" size="large"></lm-ng-select>
      <div class="w-36">
        <lm-ng-select placeholder="Placeholder" [data]="selectData" [borderless]="true"></lm-ng-select>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-3/12">
      <h2 class="font-bold uppercase mb-4">Search bar</h2>
      <lm-search-bar label="Title input" placeholder="Search"></lm-search-bar>
    </lm-column>
    <lm-column class="w-3/12">
      <h2 class="font-bold uppercase mb-4">Toggle</h2>
      <lm-toggle></lm-toggle>
      <lm-toggle size="large"></lm-toggle>
    </lm-column>
    <lm-column class="w-3/12">
      <h2 class="font-bold uppercase mb-4">Toggle with label</h2>
      <lm-toggle label="Toggle label"></lm-toggle>
      <lm-toggle size="large" label="Toggle label"></lm-toggle>
    </lm-column>
    <lm-column class="w-3/12">
      <h2 class="font-bold uppercase mb-4">ICON SWITCH</h2>
      <lm-icon-switch [icon_on]="faEdit" [icon_off]="faClose" [text_on]="'ESPANDI'" [text_off]="'RIDUCI'" [value]="s_button" (onValueChange)="this.onValueChange($event)"></lm-icon-switch>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-6/12">
      <h2 class="font-bold uppercase mb-4">Tabs</h2>
      <lm-tabs>
        <lm-tab [title]="'PLACEHOLDER'" [active]="true">Lorem ipsum</lm-tab>
        <lm-tab [title]="'PLACEHOLDER'">Lorem ipsum 2</lm-tab>
        <lm-tab [title]="'PLACEHOLDER'">Lorem ipsum 3</lm-tab>
      </lm-tabs>
    </lm-column>
    <lm-column class="w-6/12">
      <h2 class="font-bold uppercase mb-4">Tabs with chips</h2>
      <lm-tabs type="chips">
        <lm-tab [title]="'PLACEHOLDER'" [active]="true">Lorem ipsum</lm-tab>
        <lm-tab [title]="'PLACEHOLDER'">Lorem ipsum 2</lm-tab>
        <lm-tab [title]="'PLACEHOLDER'">Lorem ipsum 3</lm-tab>
      </lm-tabs>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column>
      <h2 class="font-bold uppercase mb-4">Pagination</h2>
      <div class="flex gap-x-10">
        <lm-query-builder-pagination [pagination]="{ limit: 10, count: 40, skip: 0 }"></lm-query-builder-pagination>
        <lm-query-builder-pagination [pagination]="{ limit: 10, count: 100, skip: 10 }"></lm-query-builder-pagination>
      </div>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-full">
      <h2 class="font-bold uppercase mb-4">Basic table</h2>
      <lm-data-table [data]="dataTable">
        <span lmDataTableColumn label="Placeholder" property="1"></span>
        <span lmDataTableColumn label="Placeholder" property="2"></span>
        <span lmDataTableColumn label="Placeholder" property="3"></span>
        <span lmDataTableColumn label="Placeholder" property="4"></span>
        <span lmDataTableColumn label="Placeholder" property="5"></span>
        <span lmDataTableColumn label="Placeholder" property="6"></span>
        <span lmDataTableColumn label="Placeholder funcion">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end gap-x-4">
              <lm-toggle></lm-toggle>
              <lm-icon [icon]="faEdit"></lm-icon>
              <lm-icon [icon]="faDelete"></lm-icon>
            </div>
          </ng-template>
        </span>
      </lm-data-table>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-full">
      <h2 class="font-bold uppercase mb-4">Table stripes</h2>
      <lm-data-table [data]="dataTable" [stripes]="true" title="TITLE HEADER TABLE" headerColor="primary">
        <span lmDataTableColumn label="Placeholder" property="1"></span>
        <span lmDataTableColumn label="Placeholder" property="2"></span>
        <span lmDataTableColumn label="Placeholder" property="3"></span>
        <span lmDataTableColumn label="Placeholder" property="4"></span>
        <span lmDataTableColumn label="Placeholder" property="5"></span>
        <span lmDataTableColumn label="Placeholder" property="6"></span>
        <span lmDataTableColumn label="Placeholder funcion">
          <ng-template #dataTableCell let-item="item">
            <div class="flex items-end gap-x-4">
              <lm-toggle></lm-toggle>
              <lm-icon [icon]="faEdit"></lm-icon>
              <lm-icon [icon]="faDelete"></lm-icon>
            </div>
          </ng-template>
        </span>
      </lm-data-table>
    </lm-column>
  </lm-row>
  <lm-row>
    <lm-column class="w-6/12">
      <h2 class="font-bold uppercase mb-4">Text area</h2>
      <div class="flex gap-x-5">
        <lm-textarea label="Title input" placeholder="Placeholder" [rows]="7" [cols]="50"></lm-textarea>
        <lm-chips-textarea
          [chipsList]="chipsList"
          class="w-full max-w-sm"
          label="Title input"
          placeholder="Placeholder"
          [addButtonText]="t('add')"
        ></lm-chips-textarea>
      </div>
    </lm-column>
    <lm-column class="w-6/12">
      <h2 class="font-bold uppercase mb-4">Radio button</h2>
      <form [formGroup]="radioForm" (ngSubmit)="checkValue()">
        <lm-radio-button
          formControlName="test"
          groupName="status"
          label="Placeholder 1"
          title="Title input"
          valueName="test1"
          selected="test1"
        ></lm-radio-button>
        <lm-radio-button
          formControlName="test"
          groupName="status"
          label="Placeholder 2"
          valueName="test2"
          [styles]="this.backred()"
          selected="test1"
        ></lm-radio-button>
      </form>
    </lm-column>
  </lm-row>
  <!-- <lm-row>
    <lm-column class="w-full">
      <lm-calendar-view [currentMonth]="currentMonth"></lm-calendar-view>
    </lm-column>
  </lm-row> -->
  
  <!-- <form [formGroup]="rangeForm" (ngSubmit)="selectedMonth()"> -->
  <input #flatpickr class="border border-blue-500" (ngModelChange)="selectedMonth()" [value]="testMonth" />
  <button (click)="selectedMonth()">Cerca</button>
  <br />

  <lm-dropdown>
    <button lmDropdownToggle>Click</button>
    <ul lmDropdownContainer class="table-dropdown">
      <li>11111</li>
      <li>22222</li>
      <li>33333</li>
    </ul>
  </lm-dropdown>
</lm-container>
